import { render, staticRenderFns } from "./Membros.vue?vue&type=template&id=31cbed6e"
import script from "./Membros.vue?vue&type=script&lang=js"
export * from "./Membros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports